import { Pagination } from '@consigli/facade';
import { FC, ReactNode } from 'react';

import { MultiOpenAccordion } from '@/components/accordion/accordion-multi-open';

import { ComponentCard, ComponentReference, ScheduleComponent } from './component-card';

interface ComponentSectionProps {
  index: number;
  title: string;
  icon: ReactNode;
  badgeColor: string;
  count: number;
  components: ScheduleComponent[];
  currentPage: number;
  pageSize: number;
  defaultOpen?: boolean;
  onPageChange: (page: number) => void;
  onPageClick: (clicked: ComponentReference, schedule?: ComponentReference) => void;
  onScheduleOnlyClick?: (schedule: ComponentReference) => void;
  activeComponentId?: string | null;
  registerCard?: (id: string) => (node: HTMLDivElement | null) => void;
}

export const ComponentSection: FC<ComponentSectionProps> = ({
  index,
  title,
  icon,
  badgeColor,
  count,
  components,
  currentPage,
  pageSize,
  defaultOpen = false,
  onPageChange,
  onPageClick,
  onScheduleOnlyClick,
  activeComponentId = null,
  registerCard,
}) => {
  if (components.length === 0) return null;

  return (
    <MultiOpenAccordion
      index={index}
      bgColor="bg-day-light-4"
      headerBgColor="bg-day-light-4"
      defaultOpen={defaultOpen}
      header={() => (
        <div className="flex items-center gap-2">
          {icon}
          <span className="text-lg font-semibold text-gray-900">{title}</span>
          <span className={`px-2 py-0.5 rounded-full text-sm font-medium ${badgeColor}`}>
            {count}
          </span>
        </div>
      )}
    >
      <div className="max-h-[600px] overflow-y-auto overflow-x-hidden px-1 py-3 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent hover:scrollbar-thumb-gray-400">
        {components.map((component) => (
          <ComponentCard
            key={component.id}
            component={component}
            selected={component.id === activeComponentId}
            onPageClick={onPageClick}
            onScheduleOnlyClick={onScheduleOnlyClick}
            registerCard={registerCard}
          />
        ))}
      </div>
      {count > pageSize && (
        <div className="pt-4 flex justify-center">
          <Pagination
            currentPage={currentPage}
            totalCount={count}
            pageSize={pageSize}
            onPageChange={onPageChange}
          />
        </div>
      )}
    </MultiOpenAccordion>
  );
};
